module.exports = __webpack_public_path__ + "img/uploadTray.cff9dd8d.svg";